export default "__VITE_ASSET__ff9tvhFj__";